import $ from 'jquery'
import navbarFixedTop from '@/navbar-fixed-top'

export const initializeNavbar = () => {
  // Show the sticky nav once the user scrolls past the warning if it it exists, or the eco message such that the sticky
  // personalize button appears directly on top of the on-page personalize button.
  navbarFixedTop(
    $('#prod-main .personalize-big'),
    $('.sticky-top-nav'),
    // Hide the on-page personalize and favorite buttons so they aren't visible behind the sticky nav
    $('#prod-main .personalize-big, #prod-main .favorite.btn'),
    // Factor in the padding from the navbar (above the Personalize button), so that the navbar appearance is smoother
    parseInt($('.layout-product .navbar-fixed-top').css('padding-top'))
  )
}
